export const MANAGEMENT_PROFILE_HEADERS: { label: string; lockKey?: 'riskAlerts' | 'regulatoryChecks' | 'legalCases' }[] = [
    { label: 'Name' },
    { label: 'Designation' },
    { label: 'Tenure' },
    { label: 'Contact' },
    { label: 'Risk Alerts', lockKey: 'riskAlerts' },
    { label: 'Regulatory Checks', lockKey: 'regulatoryChecks' },
    { label: 'Legal Cases', lockKey: 'legalCases' },
    { label: 'Status' },
];

export const LOCKED_COLUMN_TOOLTIPS: Record<'riskAlerts' | 'regulatoryChecks' | 'legalCases', string> = {
    riskAlerts: 'Unlock Structure & Relations to view risk alerts',
    regulatoryChecks: 'Unlock Legal & Risk Checks to view regulatory checks',
    legalCases: 'Unlock Legal & Risk Checks to view legal cases',
};

export type ColumnLockKey = 'riskAlerts' | 'regulatoryChecks' | 'legalCases';

export const KARZA_DIN_STEP = 'AION_KARZA_DIN_DETAILS';

export const PROBE_MERGE_WAIT_MS = 30_000;
